import { render } from "./StudentPublicResource.vue?vue&type=template&id=210e734b&scoped=true"
import script from "./StudentPublicResource.vue?vue&type=script&lang=js"
export * from "./StudentPublicResource.vue?vue&type=script&lang=js"

import "./StudentPublicResource.vue?vue&type=style&index=0&id=210e734b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210e734b"]])

export default __exports__